module.exports = __webpack_public_path__ + "resources/img/certi_iso_iec_27701.2e4dfa3eeea7466218a6775a6c8a723c.png";